import { c as _c } from "react/compiler-runtime";
import CommonPagesections from "@/components/common/CommonPagesections";
export default function CatSections(t0) {
  const $ = _c(4);
  const {
    sections: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const sections = t2;
  let t3;
  if ($[2] !== sections) {
    t3 = <CommonPagesections sections={sections} />;
    $[2] = sections;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}